import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { updateTutorialVideoSaga } from "src/store/tutorials/saga";
import { TutorialVideoDto } from "src/store/tutorials/type";
import * as Yup from "yup";

const TutorialVideoEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: TutorialVideoDto & { Translates?: any[] };
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);

  return (
    <FormDrawer
      drawerProps={{
        isOpen: open,
        onHide: onHide,
        title: t("Tutorials.EditVideo").toString(),
      }}
      onHide={onHide}
      loader
      initialValues={{
        Id: data.Id,
        TutorialPlaylistId: data.TutorialPlaylistId,
        Title: data.Title,
        Description: data.Description,
        Order: data.Order,
        DurationSec: data.DurationSec,
        IsActive: data.IsActive,
        Video: data.Video, // mevcut dosya linki (fileField ile gösterilir)
        Poster: data.Poster,
        VideoFile: undefined, // yalnızca değiştirilecekse yüklenir
        PosterFile: undefined,
        Translates: languages.map((l) => {
          const tr = (data.Translates || []).find(
            (x: any) => x.LanguageId === l.EnumId
          );
          return {
            LanguageId: l.EnumId,
            Title: tr ? tr.Title || "" : "",
            Description: tr ? tr.Description || "" : "",
          };
        }),
      }}
      onSubmit={(values) => {
        dispatch(
          updateTutorialVideoSaga({
            payload: {
              onSuccess: (message) => {
                onHide();
                onSuccessClick(message);
              },
              onError: (message) => toast.error(message, { theme: "colored" }),
            },
            id: data.Id,
            body: values,
          })
        );
      }}
      validationSchema={Yup.object().shape({})}
      multilanguageinputs={[
        { field: "Title", label: t("Tutorials.Title").toString() },
        { field: "Description", label: t("Tutorials.Description").toString() },
      ]}
      inputs={[
        { field: "Order", label: t("Tutorials.Order").toString(), type: "number" },
        {
          field: "DurationSec",
          label: t("Tutorials.DurationSec").toString(),
          type: "number",
        },
        { field: "IsActive", label: t("Tutorials.IsActive").toString(), type: "switch" },
        {
          field: "VideoFile",
          label: t("Tutorials.VideoFileReplace").toString(),
          type: "file",
          accept: "video/*",
          fileField: "Video",
        },
        {
          field: "PosterFile",
          label: t("Tutorials.PosterFileReplace").toString(),
          type: "file",
          accept: "image/*",
          fileField: "Poster",
        },
      ]}
    />
  );
};
export default TutorialVideoEditForm;
